@if (globalLoading) {
  <div
    style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background-color: rgba(255,255,255,0.7); display: flex; justify-content: center; align-items: center; z-index: 9999;">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="container-fluid">
  <div class="row">
    <div class="col-sm-12 body-content  body-client-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
